/**
 * @generated SignedSource<<5865ee1a7309355522ce1df70707e46a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LoginActivateInput = {
  clientMutationId?: string | null | undefined;
  login: LoginActivate;
};
export type LoginActivate = {
  activationKey: string;
  email: string;
  password: string;
  passwordConfirmation: string;
};
export type EmailLoginActivateMutation$variables = {
  input: LoginActivateInput;
};
export type EmailLoginActivateMutation$data = {
  readonly loginActivate: {
    readonly errors: ReadonlyArray<{
      readonly messages: ReadonlyArray<string>;
      readonly path: string;
    }>;
  };
};
export type EmailLoginActivateMutation = {
  response: EmailLoginActivateMutation$data;
  variables: EmailLoginActivateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "messages",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailLoginActivateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LoginActivatePayload",
        "kind": "LinkedField",
        "name": "loginActivate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Error",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "EmailLoginActivateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LoginActivatePayload",
        "kind": "LinkedField",
        "name": "loginActivate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Error",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "024af793f5a5d6dd9014bf74a0ddf643",
    "id": null,
    "metadata": {},
    "name": "EmailLoginActivateMutation",
    "operationKind": "mutation",
    "text": "mutation EmailLoginActivateMutation(\n  $input: LoginActivateInput!\n) {\n  loginActivate(input: $input) {\n    errors {\n      path\n      messages\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "03e2bd65bf0e61a0be5fcb44560d9f7f";

export default node;
